import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  openFaqIndex: number | null = null;

  constructor(private meta: Meta) {}

  ngOnInit(): void {
    this.meta.updateTag({ name: 'description', content: 'Chareety is a free nonprofit donation platform. Accept credit card, cash, and check donations in person and online. Kiosk devices, donor management, automatic tax receipts, and 130+ languages. Built for mosques, churches, temples, and food banks.' });
    this.meta.updateTag({ name: 'keywords', content: 'nonprofit donation platform, free donation software, kiosk donations, donor management, tax receipts, mosque donations, church donations, online giving, Stripe donations, nonprofit fundraising' });
  }

  faqItems = [
    {
      question: 'How long does onboarding take?',
      answer: 'Most organizations are fully set up within 30-60 minutes. You\'ll provide your organization\'s EIN, connect a bank account through Stripe Express, and configure your giving page. Our guided wizard walks you through every step. You can start accepting donations the same day.'
    },
    {
      question: 'What payment methods can we accept?',
      answer: 'Donors can give via credit card, debit card, Apple Pay, Google Pay, and other digital wallets through our Stripe integration. You can also manually record cash, check, and Zelle donations. Our physical terminals and Mobile Box (patent pending) seamlessly accept both in-person digital and cash payments.'
    },
    {
      question: 'Are the donation receipts tax-compliant?',
      answer: 'Yes. Chareety automatically generates IRS-compliant donation receipts including your organization\'s EIN, the donation amount, date, and standard tax-deductibility language. Year-end contribution statements are also generated for your donors automatically, eliminating manual administrative work.'
    },
    {
      question: 'How much does Chareety cost?',
      answer: 'Our core platform is truly free—no setup costs and no monthly fees. You simply pay standard processing fees (e.g., 2.9% + 30¢) per digital transaction. We also offer premium plans with advanced features like hardware support and email broadcasts, as well as custom enterprise pricing.'
    },
    {
      question: 'Is Chareety suitable for all types of nonprofits?',
      answer: 'Absolutely. We serve a wide variety of organizations including mosques, churches, temples, synagogues, food banks, youth organizations, schools, and any registered 501(c)(3). Our flexible platform is designed to scale with community nonprofits, faith-based organizations, and charities of all sizes.'
    },
    {
      question: 'How and when do we receive our funds?',
      answer: 'Funds are deposited directly into your organization\'s bank account via Stripe Connect. Payouts typically arrive within two business days. You maintain full access to detailed transaction reports, payout schedules, and automated reconciliation tools from your dashboard.'
    },
    {
      question: 'What is a Mobile Box?',
      answer: 'The Mobile Box (patent pending) is our portable donation terminal that allows you to securely collect cash, checks, and digital payments anywhere—from community events to farmers markets. It connects via an optional cellular SIM card or free standard WiFi. Every transaction automatically syncs to your Chareety dashboard in real time.'
    }
  ];

  navigateToOnboard(): void {
    const onboardUrl = environment.appUrls?.onboard || 'https://onboard.chareety.com';
    window.open(`${onboardUrl}?source=marketing`, '_blank');
  }

  toggleFaq(index: number): void {
    this.openFaqIndex = this.openFaqIndex === index ? null : index;
  }

  scrollToContact(): void {
    const el = document.getElementById('contact');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
